import React from "react";
import {Popup} from "react-map-gl";
import {Stack, Typography} from "@mui/material";

interface KeyValueInlineProps {
    header: string;
    value: string;
}

const KeyValueInline: React.FC<KeyValueInlineProps> = ({header, value}) => {
    return (
        <Stack direction="row" gap="0.5rem" justifyContent="left" alignItems="center">
            <Typography textTransform="uppercase" component="div" variant="h5">
                {header}:
            </Typography>
            <Typography textTransform="capitalize" sx={{color: "#737990"}} variant="h5" textOverflow="ellipsis">
                {value}
            </Typography>
        </Stack>
    );
};

interface PopupProps {
    details: {
        featureName: string;
        cropType: string;
        plantedDate: string;
        soilType: string;
        irType: string;
        lngLat: {lng: number; lat: number};
    };
    t: (key: string) => string;
}

export const MapPopup: React.FC<PopupProps> = ({details, t}) => {
    const {featureName, cropType, plantedDate, soilType, irType, lngLat} = details;
    return (
        <Popup
            longitude={lngLat.lng}
            latitude={lngLat.lat}
            closeButton={false}
            closeOnClick={false}
            anchor="top"
            maxWidth="none"
        >
            <Stack
                direction="column"
                gap="0.25rem"
                alignItems="flex-start"
                justifyContent="center"
                p={"0.25rem"}
                useFlexGap
                maxWidth="25rem"
            >
                <KeyValueInline header={t("dialogs.field_create.form.field_name")} value={featureName} />
                <KeyValueInline header={t("dialogs.field_create.crop_widget.crop")} value={cropType} />
                <KeyValueInline header={t("dialogs.field_create.crop_widget.planted_date")} value={plantedDate} />
                <KeyValueInline header={t("dialogs.field_create.form.soil_type")} value={soilType} />
                <KeyValueInline header={t("dialogs.field_create.form.irrigation_type")} value={irType} />
            </Stack>
        </Popup>
    );
};
